(function () {
  const mobile = window.matchMedia('(max-width: 768px)');
  const isOpen = 'footer__navigation-header--open';
  const trigger = qsa('.js-footer_navigation-header');
  const list = qsa('.js-footer-navigation-list');

  var lastActiveTool;

  trigger.forEach((item) => {
    item && item.addEventListener('click', (e) => {
      if (mobile.matches) { 
        const parent = e.currentTarget.closest('.js-footer__navigation');
        const content = parent.querySelector('.js-footer-navigation-list');     
        if (e.target.classList.contains(isOpen)) {
          e.currentTarget.classList.remove(isOpen)
          content.style.height = '0';

        } else {
          const list = qsa('.js-footer-navigation-list');    
          trigger.forEach((item) => {
            item.classList.remove(isOpen);
          });
          list.forEach(item => {
            item.style.height = 0;
          })
          
          e.currentTarget.classList.add(isOpen);
          content.style.height = `${content.scrollHeight}px`;
        }
      }
    });
    mobile.addEventListener('change', () => {
      if (!mobile.matches) {
        item && (item.classList.remove(isOpen));
    
        list.forEach((el) => {
          el.removeAttribute('style');
        });
      }
    });
  });
})();
